// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1c0yY","title":"styles_title__3nD6_","childrenBlock":"styles_childrenBlock__2mDub"};